import "core-js/modules/es6.array.map.js";
import { MigrationError } from '@nerdwallet/structured-content-core/migrations';
import { COLUMNS, NOOP } from '../../../types'; // eslint-disable-next-line camelcase

var migrateColumnsFrom_1_0_0_to_2_0_0 = function migrateColumnsFrom_1_0_0_to_2_0_0(_ref) {
  var type = _ref.type,
      version = _ref.version,
      props = _ref.props;

  if (version !== '1.0.0') {
    throw new MigrationError("".concat(COLUMNS, " v2.0.0 migrator should only operate on ").concat(COLUMNS, " v1.0.0 nodes, got: v").concat(version));
  }

  var columnGap = props.columnGap,
      columns = props.columns;
  if (!columns.length) return {
    type: NOOP,
    version: '1.0.0',
    props: {}
  };
  var columnWidth = Math.floor(12 / columns.length);
  var newProps = {
    spacing: columnGap,
    // Use vertical alignment of first column
    alignY: columns[0].verticalAlign || 'top',
    children: columns.map(function (_ref2) {
      var children = _ref2.children;
      return {
        type: 'Column',
        version: '1.0.0',
        props: {
          children: children,
          width: columnWidth
        }
      };
    })
  };
  return {
    type: type,
    version: '2.0.0',
    props: newProps
  };
}; // eslint-disable-next-line camelcase


export default migrateColumnsFrom_1_0_0_to_2_0_0;